import { useState, useEffect, useContext } from 'react';
import './PublishModal.css';
import ToggleSwitch from '../ToggleSwitch';
import { AuthContext } from '../../authContext';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução
import AddUserModal from './AddUserModal';
import AlertsCustom from '../Alerts/index';

function PublishModal({ isOpen, onClose, nome, createdBy, users, updateUserList, status, handleStatus, email }) {

    const { accessToken, userName } = useContext(AuthContext);
    const { t: tSelfAssist } = useTranslation('assistantConfiguration');
    const { t: tCommon } = useTranslation('common');

    // Estado "oficial" vem das props, mas as mudanças ficam em estados temporários até salvar
    const [tempUsersList, setTempUsersList] = useState([]);
    const [tempStatus, setTempStatus] = useState(status); // Estado temporário do switch 
    const [showAddUserModal, setShowAddUserModal] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [alertTitle, setAlertTitle] = useState("");
    const [alertType, setAlertType] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        // Sempre que abrir o modal, reseta os valores temporários
        if (isOpen) {
            // O "owner" deve ser o criador verdadeiro do assistente
            const ownerEmail = createdBy || '';
            // Exibimos o owner como o primeiro item e os demais como usuários com acesso
            setTempUsersList([{ user: ownerEmail, email: ownerEmail }, ...(Array.isArray(users) ? users : [])]);
            setTempStatus(status);
        }

    }, [isOpen, createdBy, users, status]);

    useEffect(() => {
        if (!showAddUserModal) return;

        fetch(`${process.env.REACT_APP_API_URL}/get_list_users`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        })
            .then(res => res.json())
            .then(data => setAllUsers(data))
            .catch(err => {
                console.error("Erro ao carregar usuários:", err);
                //alert("Erro ao carregar usuários.");
                setAlertTitle("Erro");
                setAlertType("error")
                setAlertMessage(tSelfAssist('erro_usuarios'))
                setShowAlert(true);
            });
    }, [showAddUserModal, accessToken, tSelfAssist]);


    if (!isOpen) return null;

    // Função para fechar o modal ao clicar fora do conteúdo
    const handleClickOutside = (event) => {
        if (event.target.classList.contains('modal-overlay-publish')) {
            handleCloseModal();
        }
    };

    // Função para fechar o modal e redefinir estados
    const handleCloseModal = () => {
        onClose();
    };

    // Filtra os usuários com acesso (excluindo o proprietário) baseado no termo de busca
    const filteredUsers = tempUsersList.slice(1).filter(user =>
        user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Remover usuário ao clicar no ícone
    const handleRemoveUser = (email) => {
        setTempUsersList(prevUsers => prevUsers.filter(user => user.email !== email));
    };

    // Função para alternar o estado do assistente no estado temporário
    const handleTempStatusToggle = () => {
        setTempStatus((prev) => !prev);
    };

    // Aplicar todas as mudanças ao clicar em "Salvar mudanças"
    const handleSaveChanges = () => {
        // Ignora o primeiro usuário (proprietário) e atualiza apenas os demais
        const filteredUsers = tempUsersList.slice(1);

        // Atualiza a lista de usuários sem o primeiro
        updateUserList(filteredUsers);

        // Atualiza o status real
        if (tempStatus !== status) {
            handleStatus();
        }

        // Fecha o modal
        handleCloseModal();
    };


    return (
        <>
            <div className='modal-overlay-publish' onClick={handleClickOutside}>
                <div className='modal-content-publish'>

                    <p className='publish-title'>{tSelfAssist("share_access")} {nome}</p>
               
                    {/* Exibe apenas o proprietário primeiro */}
                    {tempUsersList.length > 0 && (
                        <div className='user-about owner-section'>
                            <div className='involucro-user'>
                                <div className="header__user-initial">
                                    {tempUsersList[0].email.charAt(0).toUpperCase()}
                                </div>
                            </div>
                            <div className='user-info' >
                                {(() => {
                                    // Se o usuário logado é o criador, usamos o nome dele; caso contrário, usamos o e-mail do criador
                                    const isViewerOwner = tempUsersList[0].email && tempUsersList[0].email === email;
                                    const ownerDisplayName = isViewerOwner ? (userName || email) : (tempUsersList[0].user || tempUsersList[0].email);
                                    return (
                                        <>
                                            <p className='user-name'>{ownerDisplayName}</p>
                                            <p className='user-email'>{tempUsersList[0].email}</p>
                                        </>
                                    );
                                })()}
                            </div>
                            <div className='user-control'>
                                <p className='user-level'>{tCommon("owner")}</p>
                            </div>
                        </div>
                    )}

                    <div className='publish-buttons-wrapper'>
                        <button data-testid="button-search" className='button-search' onClick={() => setShowAddUserModal(true)}>
                            {tSelfAssist("add_user")}
                            <img src='/imagens/add-user.svg' className='search-icon-button' alt={tSelfAssist("add_user")} />
                        </button>

                        <div className='search-container-input'>
                            <input
                                type='text'
                                className='publish-input-popup'
                                placeholder={tSelfAssist("search_users")}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <img src='/imagens/search.svg' className='search-icon' alt={tSelfAssist("search_users")} />
                        </div>
                    </div>
                    
                    <div className='submited-users-list'>

                    <p className='publish-subtitle'>{tSelfAssist("people_with_access")}</p>
                    
                    <div className='users-list-wrapper'>

                        <div className='users-list'>
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((userData, index) => (
                                    <div key={index} className='user-about'>
                                        <div className='involucro-user'>
                                            <div className="header__user-initial">
                                                {userData.email.charAt(0).toUpperCase()}
                                            </div>
                                        </div>

                                        <div className='user-info' data-testid="user-info">
                                            <p className='user-name'>{userData.user}</p>
                                            <p className='user-email' title={userData.email}>{userData.email}</p>
                                        </div>

                                        <div className='user-control'>

                                            <p className='user-level'>{tCommon("user")}</p>
                            <img
                                src="/imagens/exclude-red.svg"
                                alt={tCommon("removeUserIcon")}
                                className="remove-user-icon"
                                
                                onClick={() => handleRemoveUser(userData.email)}
                            />                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className='no-users-message'>{tSelfAssist("no_user_found")}</p>
                            )}
                            {showAlert && (
                                <AlertsCustom
                                    type={alertType}
                                    title={alertTitle}
                                    message={alertMessage}
                                    onClose={() => setShowAlert(false)}
                                />
                            )}
                        </div>

                    </div>

                    </div>

                    <div className='assistant-activation'>
                        <p className='publish-subtitle'>{tSelfAssist("assistant_status")}</p>

                        <div className='assistant-status'>
                            <span className={`status-text ${tempStatus ? 'active' : 'inactive'}`}>
                                {tempStatus ? tCommon("active") : tCommon("disabled")}
                            </span>
                            <ToggleSwitch isChecked={tempStatus} onToggle={handleTempStatusToggle} />
                        </div>
                    </div>

                    <div className='central-button'>
                        <button data-testid="salvarMudancas" className='gray-button higher' onClick={handleSaveChanges}> {tSelfAssist("save_changes")} </button>
                    </div>

                </div>

            </div>

            <AddUserModal
                isOpen={showAddUserModal}
                setShowAddUserModal={setShowAddUserModal}
                tempUsersList={tempUsersList}
                setTempUsersList={setTempUsersList}
                allUsers={allUsers}
                setAllUsers={setAllUsers}
                size="default"
                showEmailModeButton={true}
                showFooterButtons={true}
            />
        </>
    );
}

export default PublishModal;